<template>
    <main-content>
        <kt-panel-body v-if="ip_location !== 'IR'">
            <div class="alert alert-danger" role="alert">
                {{ $t('label.ir_ip_error') }}
            </div>
        </kt-panel-body>
        <card-to-card-form v-else :form_data="form_data" :submit="submit"></card-to-card-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import CardToCardForm from './components/form'
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {authService, cardToCardService} from '@/common/api.service'
import {i18n} from '@/plugins/i18n'

export default {
    components: {
        'main-content': mainContent,
        'card-to-card-form': CardToCardForm
    },
    computed: {
        form_data: {
            get: function () {
                return this.$store.state.cardToCard.form_data
            },
            set: function (value) {
                this.$store.commit('cardToCard/setFormData', value)
            }
        }
    },
    data() {
        return {
            ip_location: ''
        }
    },
    mounted() {
        authService.get_ip().then(response => {
            this.ip_location = response.data.countryCode;
        });
    },
    methods: {
        submit(e) {
            let form = $('#card_to_card_form');
            let btn = $('#submit_btn');
            if (this.form_data.gateway_cards.length < 1)
                return this.toastr.error(i18n.t('card_to_card.message.at_least_one_card'))
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    website: {
                        required: true,
                    },
                    callback_address: {
                        required: true,
                    },
                    logo: {
                        required: true,
                    },
                    merchant_share_percent: {
                        required: true,
                        maxlength: 100,
                        minlength: 0,
                        number: true
                    },
                }
            });

            if (!form.valid()) {
                return;
            }
            let error = 0
            for (let i = 0; i < this.form_data.gateway_cards.length; i++) {
                let has_error = this.validateCard(this.form_data.gateway_cards[i], i)
                if (has_error)
                    error++;
            }
            if (error > 0)
                return;

            KTApp.progress(btn);
            let params = structuredClone(this.$store.getters['cardToCard/form_data']);
            if (params.gateway_cards.length > 0) {
                for (let i = 0; i < params.gateway_cards.length; i++) {
                    params.gateway_cards[i].card_number = '603769' + params.gateway_cards[i].card_number
                }
            }else {
                params.gateway_cards = null
            }

            cardToCardService.create(params).then(response => {
                this.$store.dispatch('gateway/gatewayTab', 2)
                this.$router.push('/gateways')
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
                for (let err in response.data.data) {
                    this.showMsg(form, 'danger', response.data.data[err][0]);
                }
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        validateCard(card, index) {
            let has_error = false;
            if (!card.card_number) {
                document.getElementById('card_number_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('card_number' + index).style.borderColor = '#fd397a'
                has_error = true;
            } else if (!this.validateCardNumber('603769' + card.card_number)) {//saderat
                document.getElementById('card_number_error' + index).innerText = i18n.t('card_to_card.message.card_number_is_not_valid')
                document.getElementById('card_number' + index).style.borderColor = '#fd397a'
                has_error = true;
            } else {
                let is_duplicate = false;
                for (var i = 0; i < this.form_data.gateway_cards.length; i++) {
                    if (this.form_data.gateway_cards[i].card_number === card.card_number && i !==index) {
                        is_duplicate = true;
                        break;
                    }
                }
                if (is_duplicate) {
                    document.getElementById('card_number_error' + index).innerText = i18n.t('card_to_card.message.card_number_is_duplicate')
                    document.getElementById('card_number' + index).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('card_number_error' + index).innerText = ''
                    document.getElementById('card_number' + index).style.borderColor = '#e2e5ec'
                }
            }

            if (!card.account_number) {
                document.getElementById('account_number_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('account_number' + index).style.borderColor = '#fd397a'
                has_error = true;
            } else {
                document.getElementById('account_number_error' + index).innerText = ''
                document.getElementById('account_number' + index).style.borderColor = '#e2e5ec'
            }
            if (!card.card_owner_name) {
                document.getElementById('card_owner_name_error' + index).innerText = i18n.t('application.message.field_required')
                document.getElementById('card_owner_name' + index).style.borderColor = '#fd397a'
                has_error = true;
            } else {
                document.getElementById('card_owner_name_error' + index).innerText = ''
                document.getElementById('card_owner_name' + index).style.borderColor = '#e2e5ec'
            }

            return has_error;
        },
        validateCardNumber(code) {
            var l = code.length;
            if (l < 16 || parseInt(code.substr(1, 10), 10) == 0 || parseInt(code.substr(10, 6), 10) == 0) return false;
            var c = parseInt(code.substr(15, 1), 10);
            var s = 0;
            var k, d;
            for (var i = 0; i < 16; i++) {
                k = (i % 2 == 0) ? 2 : 1;
                d = parseInt(code.substr(i, 1), 10) * k;
                s += (d > 9) ? d - 9 : d;
            }
            return ((s % 10) == 0);
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.commit('cardToCard/clearFormData')
        })
    },
}
</script>

<style>

</style>
